module.exports = __webpack_public_path__ + "img/fast-inserter-platform.a50dadec.png";